__turbopack_context__.v({
  "consultant-details": "ConsultantDetails-module-scss-module__NztCDG__consultant-details",
  "consultant-details__avatar": "ConsultantDetails-module-scss-module__NztCDG__consultant-details__avatar",
});
